import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { usePopper } from 'react-popper'
import { COLORS } from '@helpers/constants'
import { AnimatePresence, motion } from 'framer-motion'

const Tooltip = (props) => {
  const {
    referenceElement,
    show,
    onHide,
    color = COLORS.MEDIUM_DARK_GREY,
    placement,
    maxWidth,
    offset,
  } = props
  const [popperElement, setPopperElement] = useState(null)
  const [arrowElement, setArrowElement] = useState(null)
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: placement,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: offset ?? [0, 20],
        },
      },
      { name: 'arrow', options: { element: arrowElement, padding: 20 } },
    ],
  })

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (referenceElement && !referenceElement.contains(event.target)) {
        onHide && onHide()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [referenceElement])

  const commonArrowStyles = {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '12px solid transparent',
    borderRight: '12px solid transparent',
    ...styles.arrow,
  }

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          ref={setPopperElement}
          style={{...styles.popper, maxWidth, minWidth: '220px'}}
          {...attributes.popper}
          className={`popper-element z-10 ${color.BACKGROUND} px-4 py-3 rounded`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { delay: 0, duration: 0.1 } }}
          transition={{ delay: 0.6, duration: 0.1 }}
        >
          {props.children}

          <div
            ref={setArrowElement}
            className={color.BORDER}
            style={{
              ...commonArrowStyles,
              ...(attributes?.popper?.['data-popper-placement']?.includes(
                'bottom'
              )
                ? { bottom: '100%', borderBottomWidth: '12px' }
                : {
                    top: '100%',
                    borderTopWidth: '12px',
                  }),
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  )
}

Tooltip.propTypes = {
  referenceElement: PropTypes.object,
  show: PropTypes.bool,
  onHide: PropTypes.func,
  color: PropTypes.object,
  maxWidth: PropTypes.string,
  offset: PropTypes.array,
}

export default Tooltip
